import { render, staticRenderFns } from "./Region.vue?vue&type=template&id=3930402c&scoped=true"
import script from "./Region.vue?vue&type=script&lang=js"
export * from "./Region.vue?vue&type=script&lang=js"
import style0 from "./Region.vue?vue&type=style&index=0&id=3930402c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3930402c",
  null
  
)

export default component.exports